export const documentTypeBackSuffix = '_BACK';

export const getOverallDocumentType = (documentType: string): string => {
    return documentType.replace(documentTypeBackSuffix, '');
};

export enum OnboardingDocumentType {
    ALIEN_REG_RECEIPT_CARD_I_551 = 'ALIEN_REG_RECEIPT_CARD_I_551',
    FOREIGN_PASSPORT = 'FOREIGN_PASSPORT',
    FOREIGN_PASSPORT_MRIV = 'FOREIGN_PASSPORT_MRIV',
    FOREIGN_PASSPORT_WORK_AUTHORIZED_NON_IMMIGRANT = 'FOREIGN_PASSPORT_WORK_AUTHORIZED_NON_IMMIGRANT',
    I_551_STAMP = 'I_551_STAMP',
    PERM_RESIDENT_CARD_I_551 = 'PERM_RESIDENT_CARD_I_551',
    I_766 = 'I_766',
    I_94 = 'I_94',
    RECEIPT_FORM_I_94_I_94A = 'RECEIPT_FORM_I_94_I_94A',
    PASSPORT = 'PASSPORT',
    DRIVERS_LICENSE = 'DRIVERS_LICENSE',
    SOCIAL_SECURITY_CARD_UNRESTRICTED = 'SOCIAL_SECURITY_CARD_UNRESTRICTED',
    RECEIPT_REPLACEMENT_SS_CARD_UNRESTRICTED = 'RECEIPT_REPLACEMENT_SS_CARD_UNRESTRICTED',
    RECEIPT_REPLACEMENT_PERM_RES_CARD_FORM_I_551 = 'RECEIPT_REPLACEMENT_PERM_RES_CARD_FORM_I_551'
}



// WEBPACK FOOTER //
// ./src/dtos/document-type.ts